/* eslint-disable react-hooks/exhaustive-deps */
import { Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import IconSuccess from './Icon';
import { useTranslation } from 'react-i18next';
export default function SuccessForm() {
    const navigate = useNavigate();
    const { t } = useTranslation();
    return (
        <>
            <div className="text-center">
                <IconSuccess />
            </div>
            <div className="flex justify-center mb-12">
                <div>
                    <div className="pt-6 font-medium text-3xl text-center">
                        {t('passwordPage.SuccessfullySetPassword')}
                    </div>
                    <div className="text-sm text-[#65707A]">
                        {t('passwordPage.YourPasswordWasSetSuccessfully')}
                    </div>
                </div>
            </div>
            <div className="text-center">
                <Button
                    className="px-12"
                    type="primary"
                    size="large"
                    onClick={() => {
                        navigate('/login');
                    }}
                >
                    {t('Login')}
                </Button>
            </div>
        </>
    );
}
